import type { Place, PlacerEntityModel } from '@placer-ui/types';

export type MarketEntityModel = PlacerEntityModel<Market>;

export interface Market extends Place {
    name: string;
}

export class MarketPOI {
    static isMarketPOI(poi: Place): poi is Market {
        return poi.entity_section === 'market';
    }

    static getPrimaryCategory(poi: Place): string {
        return `${poi.category_info?.primary ?? poi.category} (Market)`;
    }

    constructor(properties: Partial<Market>) {
        Object.assign(this, properties);
    }

    static getLocationLabel(poi: Place) {
        const address =
            poi.address?.short_formatted_address || poi.address?.formatted_address || '';
        const baseCategoryLabel = this.getBaseCategoryLabel(poi);

        if (!baseCategoryLabel) {
            return address;
        }
        return `${baseCategoryLabel} • ${address}`;
    }

    static getBaseCategoryLabel(poi: Place) {
        return poi.address?.address_label;
    }
}
